import { render, staticRenderFns } from "./ProfissionalAtendimentoForm.vue?vue&type=template&id=1be6b02e"
import script from "./ProfissionalAtendimentoForm.vue?vue&type=script&lang=js"
export * from "./ProfissionalAtendimentoForm.vue?vue&type=script&lang=js"
import style0 from "./ProfissionalAtendimentoForm.vue?vue&type=style&index=0&id=1be6b02e&prod&lang=scss"
import style1 from "./ProfissionalAtendimentoForm.vue?vue&type=style&index=1&id=1be6b02e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports